import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeErrorHandlers } from './utils/errorHandler'

// Initialize global error handlers before React renders
initializeErrorHandlers();

createRoot(document.getElementById("root")!).render(<App />);
